import axios from 'axios'
import { useAppStore } from '@/storage/app'
import { addOrAppendAxiosHeader } from '@/services/axios'

const tokenRequestInterceptor = (): void => {
  axios.interceptors.request.use(
    function (config) {
      const appStore = useAppStore()

      config.headers = addOrAppendAxiosHeader(
        'x-verified-token',
        `Bearer ${appStore.token}`,
        config.headers,
      )

      return Promise.resolve(config)
    },
    function (error) {
      return Promise.reject(error)
    },
  )
}

export default tokenRequestInterceptor
